export default "__VITE_ASSET__ee1a124a__"